// extracted by mini-css-extract-plugin
module.exports = {"summary":"PageUISummary_summary__H0zGb"};